(ns ^:figwheel-hooks com.theplantscape.plant-web.prod
  (:require [com.theplantscape.plant-web.core :refer [init]]
            [com.theplantscape.plant-web.draw.state
             :refer [app-state]]))

(defn launch []
  (prn "Launched prod mode")

  ;; Load environment specific config
  (swap! app-state assoc :config
         {:backend-api-root "https://api.theplantscape.com"
          :image-root "https://api.theplantscape.com"})
  (init))

(defonce ^:export start (launch))
